type TenantUserRole = 'admin' | 'user';

export type UserFormState = {
  displayName: string;
  username: string;
  email: string;
  password: string;
  role: TenantUserRole;
};

export type EditingBaseline = {
  displayName: string;
  role: TenantUserRole;
  tenantIds: string[];
};

export type TenantChoice = {
  id: number;
  tenantId: string;
  companyName: string;
  isActive: boolean;
};

export const INITIAL_FORM: UserFormState = {
  displayName: '',
  username: '',
  email: '',
  password: '',
  role: 'admin',
};
